import React, { CSSProperties } from 'react';
import { Box, SxProps } from '@mui/system';
import { Typography, TypographyProps } from '@mui/material';
import { FaOptionIcon, NamedIconsType } from '@europrocurement/l2d-icons';

export interface TextIconProps {
    children: React.ReactNode;
    icon: Pick<NamedIconsType, 'props'>;
    iconTooltip?: string;
    typoProps?: TypographyProps;
    gap?: CSSProperties['gap'];
    sx?: SxProps;
}

export const TextIcon: React.FunctionComponent<TextIconProps> = function ({
    children,
    icon,
    iconTooltip,
    gap = '12px',
    typoProps = {},
    sx,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap,
                alignItems: 'center',
                ...sx,
            }}
        >
            <FaOptionIcon
                tooltip={iconTooltip}
                size="sm"
                {...icon.props}
            />
            <Typography
                variant="l2dbodys"
                {...typoProps}
            >
                {children}
            </Typography>
        </Box>
    );
};
